"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineDotPill = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var react_1 = __importDefault(require("react"));
function LineDotPill(_a) {
    var pillWidth = _a.pillWidth, pillHeight = _a.pillHeight, index = _a.index, points = _a.points, colors = _a.colors, config = _a.config;
    var _b = points[index], x = _b.x, y = _b.y, value = _b.value;
    return (react_1.default.createElement("g", { transform: "translate(".concat(x - pillWidth / 2 + 1, ", ").concat(y - pillHeight / 2, ")") },
        react_1.default.createElement("rect", { width: pillWidth, height: pillHeight, rx: pillHeight / 2, fill: (colors === null || colors === void 0 ? void 0 : colors.lineColor) || config.defaultColor }),
        react_1.default.createElement(kaleidoscope_1.Label, { x: pillWidth / 2, y: pillHeight / 2 + 5, textAnchor: "middle", element: "text", fill: "#fff" }, (0, FormatCurrency_1.formatCurrency)(Number(value), (config === null || config === void 0 ? void 0 : config.currency) || Types_1.CurrencyCode.AUD, 0).replace(/[^0-9,]/, ""))));
}
exports.LineDotPill = LineDotPill;
